import { SystemEntity } from "@erp/shared-types";
import { IDENTIFY_SUPPLIER_RESERVED_SOCKET_IDS } from "../../steps/ai/identify-supplier.step";
import {
  generateIdentifyPartyOutputSockets,
  resolveIdentifyPartyOutputSockets,
  type ResolvedIdentifyPartyOutputSockets,
} from "./identifyPartyOutputSockets";
import type { DynamicSocketDefinition } from "./socketDefinition";

export type ResolvedIdentifySupplierOutputSockets =
  ResolvedIdentifyPartyOutputSockets;

export function resolveIdentifySupplierOutputSockets(
  config: Record<string, unknown>,
): ResolvedIdentifySupplierOutputSockets {
  return resolveIdentifyPartyOutputSockets({
    stepType: "identify_supplier",
    reserved: IDENTIFY_SUPPLIER_RESERVED_SOCKET_IDS,
    config,
    routesConfigKey: "supplierRoutes",
    entityType: SystemEntity.AP_SUPPLIER,
    entityNoun: "Supplier",
  });
}

export function generateIdentifySupplierOutputSockets(
  config: Record<string, unknown>,
): DynamicSocketDefinition[] {
  return generateIdentifyPartyOutputSockets({
    stepType: "identify_supplier",
    reserved: IDENTIFY_SUPPLIER_RESERVED_SOCKET_IDS,
    config,
    routesConfigKey: "supplierRoutes",
    entityType: SystemEntity.AP_SUPPLIER,
    entityNoun: "Supplier",
  });
}
